import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import BadgeStyle from "components/badges/Badge.module.scss";

export const Pearl = ({size, id, className}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 64 64";
  _attributes.width = _attributes.height = size || 64;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(BadgeStyle["badge"], className);
  } else {
    _attributes.className = BadgeStyle["badge"];
  }

  return (
    <svg {..._attributes}>
      <rect x={0} y={0} width={64} height={64} className={BadgeStyle["badge__canvas"]}/>
      <g>
        <path d="M58,32c0,-14.35 -11.65,-26 -26,-26c-14.35,0 -26,11.65 -26,26c0,14.35 11.65,26 26,26c14.35,0 26,-11.65 26,-26Z" className={BadgeStyle["pearl__gradient1"]} />
        <g opacity="0.06">
          <path d="M53.571,30.181c0,12.799 -10.391,23.19 -23.189,23.19c-12.799,0 -23.189,-10.391 -23.189,-23.19c0,-12.798 10.39,-23.189 23.189,-23.189c12.798,0 23.189,10.391 23.189,23.189Z" className={BadgeStyle["pearl__fill-white"]} />
        </g>
        <g opacity="0.5">
          <path d="M48.726,26.703c0,10.122 -8.219,18.341 -18.342,18.341c-10.123,0 -18.342,-8.219 -18.342,-18.341c0,-10.123 8.219,-18.342 18.342,-18.342c10.123,0 18.342,8.219 18.342,18.342Z" className={BadgeStyle["pearl__fill-pink"]} />
        </g>
        <g opacity="0.5">
          <path d="M45.809,33.665c0,10.123 -8.219,18.34 -18.342,18.34c-10.123,0 -18.341,-8.217 -18.341,-18.34c0,-10.122 8.218,-18.34 18.341,-18.34c10.123,0 18.342,8.218 18.342,18.34Z" className={BadgeStyle["pearl__fill-pink"]} />
        </g>
        <g opacity="0.5">
          <path d="M20.361,8.515c7.218,-4.059 21.462,-3.254 27.465,3.696c6.002,6.95 6.569,11.595 6.569,13.695c0,2.167 -1.039,4.381 -4.948,7.455c-3.873,3.053 -11.917,3.053 -16.111,0c-1.9,-1.383 -7.019,-5.339 -11.587,-2.111c-1.245,0.878 -2.573,5.416 -4.857,7.821c-2.749,2.888 -6.035,4.553 -8.348,1.728c-4.736,-6.958 -3.942,-23.417 11.817,-32.284Z" className={BadgeStyle["pearl__gradient2"]} />
        </g>
        <g opacity="0.9">
          <path d="M9.191,25.065c0.582,-5.27 2.536,-8.744 6.501,-11.299c0.743,-0.479 1.859,-0.611 2.781,-0.534c1.017,0.077 1.322,0.82 0.94,1.782c-0.23,0.586 -0.541,1.154 -0.918,1.655c-2.177,2.88 -3.916,5.998 -5.27,9.343c-0.198,0.487 -0.472,0.948 -0.772,1.373c-0.703,0.969 -1.556,1.046 -2.456,0.253c-0.545,-0.48 -0.696,-1.175 -0.806,-2.573Z" className={BadgeStyle["pearl__fill-white"]} />
        </g>
        <g opacity="0.3">
          <path d="M40.377,53.371c1.048,-1.183 1.988,-2.025 2.643,-3.057c0.546,-0.852 0.721,-1.933 1.131,-2.891c0.146,-0.336 0.442,-0.659 0.757,-0.864c3.206,-2.116 6.746,-5.98 8.638,-9.548c2.676,-5.286 1.599,-2.017 1.248,-0.956c-2.452,7.334 -6.822,13.125 -13.63,16.964c-0.142,0.091 -0.303,0.146 -0.787,0.352Z" className={BadgeStyle["pearl__fill-white"]} />
        </g>
        <g opacity="0.6">
          <path d="M15.922,24.416c0.267,-2.21 1.277,-4.109 3.147,-5.514c0.221,-0.169 0.275,-0.217 0.74,-0.382c0.9,-0.23 1.958,0.305 1.244,1.486c-0.999,1.849 -2.038,3.675 -3.122,5.472c-0.238,0.395 -0.435,0.893 -1.076,0.977c-0.933,0.114 -1.01,-1.284 -0.933,-2.039Z" className={BadgeStyle["pearl__fill-white"]} />
        </g>
        <g opacity="0.7">
          <path d="M48.971,19.75c0.75,2.006 0.293,3.825 -0.388,4.345c-1.153,0.885 -1.336,-1.42 -2.086,-3.423c-0.75,-2.002 -2.53,-2.513 -1.475,-3.611c1.011,-1.062 3.195,0.68 3.949,2.689Z" className={BadgeStyle["pearl__gradient3"]} />
        </g>
      </g>
      <defs>
        <radialGradient id="_PearlRadial1" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(29.0897,3.62524,-3.68351,29.5573,28.9103,28.3748)">
          <stop offset="0" className={BadgeStyle["pearl__gradient1-stop1"]} />
          <stop offset="0.71" className={BadgeStyle["pearl__gradient1-stop2"]} />
          <stop offset="1" className={BadgeStyle["pearl__gradient1-stop3"]} />
        </radialGradient>
        <radialGradient id="_PearlRadial2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(38.0536,4.97908,-4.57732,35.4042,21.6331,19.1829)">
          <stop offset="0" className={BadgeStyle["pearl__gradient2-stop1"]} />
          <stop offset="0.2" className={BadgeStyle["pearl__gradient2-stop2"]} />
          <stop offset="0.88" className={BadgeStyle["pearl__gradient2-stop3"]} />
          <stop offset="1" className={BadgeStyle["pearl__gradient2-stop4"]} />
        </radialGradient>
        <radialGradient id="_PearlRadial3" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(5.36768,-1.25533,1.16096,4.96417,46.0048,20.0848)">
          <stop offset="0" className={BadgeStyle["pearl__gradient3-stop1"]} />
          <stop offset="0.2" className={BadgeStyle["pearl__gradient3-stop2"]} />
          <stop offset="0.88" className={BadgeStyle["pearl__gradient3-stop3"]} />
          <stop offset="1" className={BadgeStyle["pearl__gradient3-stop4"]} />
        </radialGradient>
      </defs>
    </svg>
  );
};

Pearl.defaultProps = {
  size: 64,
  className: "",
  id: ""
};

Pearl.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
